import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BreakPoint, Color, FontSize } from '../styles/constants';

const Lbl = styled.div`
  color: ${props => (props.isActive ? Color.text.darkGray : Color.text.gray)};
  font-size: ${FontSize.medium};
  line-height: 1.6875;
  text-align: left;

  @media (min-width: ${BreakPoint.desktop}) {
    font-size: ${FontSize.desktop.small};
  }

  @media (max-width: ${BreakPoint.small}) {
    font-size: ${FontSize.smallDevice.medium};
  }
`;

const Label = props => <Lbl isActive={props.isActive}>{props.children}</Lbl>;

Label.propTypes = {
  children: PropTypes.node.isRequired,
  isActive: PropTypes.bool,
};

Label.defaultProps = {
  isActive: false,
};

export default Label;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/subComponents/Label.jsx